/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const check = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M9 18.6L3.5 13l1-1L9 16.4l9.5-9.9 1 1z" />
	</SVG>
);

export default check;
